import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { NotificationProvider } from '@/contexts/NotificationContext';

export default function DashboardLayout() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#121212' }}>
      <Sidebar />
      <main style={{ flex: 1, marginLeft: 240, display: 'flex', flexDirection: 'column' }}>
        <NotificationProvider>
          <Outlet />
        </NotificationProvider>
      </main>
    </div>
  );
}
